import React, {useEffect, useRef, useState} from 'react';
import {Button} from "primereact/button";
import {Badge} from "primereact/badge";
import {AppContext} from "../../HomePage";
import {SystemHealthService} from "../../service/SystemHealthService";

// Admin-only topbar bell. Polls the cheap summary endpoint; the badge counts
// unseen active alerts, and the read-time virtual flags (worker down /
// evaluator stale) force the badge on even when everything is "seen" --
// those two mean the alerting pipeline itself is dead. Poll errors stay
// silent on purpose: a background poll must never toast-spam the admin.
const POLL_MS = 60 * 1000;

const SystemHealthBell = () => {

    const {t, toast} = React.useContext(AppContext);
    const service = useRef(new SystemHealthService()).current;
    const [summary, setSummary] = useState(null);
    const previousCritical = useRef(null);

    useEffect(() => {
        const load = () => {
            service.getSummary().then(s => {
                if (previousCritical.current !== null && s.critical > previousCritical.current) {
                    toast.current.show({severity: 'error', sticky: true,
                        summary: t('system_health.new_critical_toast'),
                        detail: t('system_health.new_critical_toast_detail', {count: s.critical})});
                }
                previousCritical.current = s.critical;
                setSummary(s);
            }).catch(() => {});
        };
        load();
        const timer = setInterval(load, POLL_MS);
        return () => clearInterval(timer);
    }, [service, t, toast]);

    const pipelineDown = summary && (summary.worker_down || summary.evaluator_stale);
    const count = summary ? summary.unseen : 0;
    const badge = pipelineDown ? <Badge value="!" severity="danger" />
        : (count > 0 ? <Badge value={count} severity={summary && summary.critical > 0 ? "danger" : "warning"} /> : "");

    return (
        <Button className="p-button-text" onClick={() => {window.location = "#/system_health";}}
                tooltip={t('system_health.bell_tooltip')} tooltipOptions={{position: 'bottom'}}>
            &nbsp;<i className="pi pi-bell p-overlay-badge">{badge}</i>
        </Button>
    );
};
export default SystemHealthBell;
